import type { FC, ReactNode } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { CardTitle } from './CardTitle'

type Props = {
  title: string
  titleLink?: string
  titleLinkDataCy?: string
  onTitleClick?: () => void
  footer?: ReactNode
  children: ReactNode
}

export const HomeCard: FC<Props> = ({
  title,
  titleLink,
  titleLinkDataCy,
  onTitleClick,
  footer,
  children
}) => (
  <CardShell data-testid="home-card">
    <TitleArea>
      {titleLink ? (
        <TitleLink
          to={titleLink}
          onClick={onTitleClick}
          data-cy={titleLinkDataCy}
        >
          <CardTitle title={title} />
        </TitleLink>
      ) : (
        <CardTitle title={title} onClick={onTitleClick} />
      )}
    </TitleArea>
    <Body>{children}</Body>
    {footer && <Footer>{footer}</Footer>}
  </CardShell>
)

const CardShell = styled.div`
  background-color: white;
  border-radius: 25px;
  padding: 18px 22px;
  min-height: 310px;
  margin-top: 18px;
  display: flex;
  flex-direction: column;
`

const Body = styled.div`
  flex: 1;
  min-height: 0;
`

const Footer = styled.div`
  padding-top: 8px;
`

const TitleArea = styled.div`
  margin-bottom: 0.5rem;
`

const TitleLink = styled(Link)`
  display: block;
  text-decoration: none;
`
